// removed by extract-text-webpack-plugin
module.exports = {"root":"Introduction__root___2icdF"};


//////////////////
// WEBPACK FOOTER
// ./app/views/Introduction/Introduction.css
// module id = 109
// module chunks = 0